<template>
    <dashboard v-if="user">
        <row>
            <panel size="col-24">
                <h3 slot="title">Assigned Courses</h3>
                <template slot="buttons">
                    <app-button size="small" @click="showCoursePicker = true">Assign Course</app-button>
                </template>
                <course-table
                    :items="user.assignedCourses"
                    :columns="['title','time','crn','location']"
                    :allow-sort="true"
                    :remote-sort="false">
                    <template slot="actions">
                        <el-table-column label="Actions" align="right" width="100">
                            <template slot-scope="scope">
                                <app-button
                                    size="mini"
                                    type="danger"
                                    icon="icon icon-delete"
                                    @click.stop="removeCourse(scope.$index, scope.row)">
                                    <span class="visuallyhidden">Remove Course</span>
                                </app-button>
                            </template>
                        </el-table-column>
                    </template>
                </course-table>
            </panel>
        </row>

        <course-picker v-model="showCoursePicker" @selected-class="assignCourse">
            <template slot="title">Select Course</template>
        </course-picker>
    </dashboard>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import CourseTable from '../Course/CourseTable'
import CoursePicker from '../Course/CoursePicker'

import User from '@/store/models/User'

export default {
    name: 'page-users-information',
    components: {
        CoursePicker,
        CourseTable
    },
    props: [ 'id' ],
    data() {
        return {
            isSaving: false,
            loading: false,
            showCoursePicker: false
        }
    },
    computed: {
        ...mapState({
            roles: ({ params }) => params.roles,
            me: ({ me }) => me.current
        }),
        user() {
            return User.query().with('assignedCourses.location').find(this.id)
        }
    },
    mounted() {
        this.getParams()
    },
    methods: {
        ...mapActions([
            'getParams'
        ]),
        navigateToCourseDetail(course) {
            this.$router.push({
                name: 'courses.detail',
                params: { uuid: course.uuid }
            })
        },
        assignCourse({ id }) {
            this.user.$attach(id, 'assignedCourses', 'addCourseToUser')
        },
        removeCourse(index, row) {
            this.user.$detach(row.id, 'assignedCourses', 'removeCourseFromUser')
        }
    }
}
</script>

<style lang="stylus"></style>
